/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-search-list',
  template: `
    <form class="searchListForm" (ngSubmit)="search()">
      <div class="row">
        <div class="col-md-3">
          <div class="input-group">
            <input type="text" [(ngModel)]="searchTerm" name="searchListTerm" class="form-control">
            <div class="input-group-btn">
              <button type="submit" class="btn btn-default">Search</button>
            </div>
          </div>
        </div>
        <div class="col-md-9 searchListStatus">
          <span *ngIf="listIsObject() && !list.searchQuery?.$resolved" style="display: inline-block; margin-left: 5px" class="fa fa-cog fa-spin"></span>
          <p *ngIf="listIsObject() && list.searchTermCommitted && list.searchQuery?.$resolved" class="form-control-static">
            <a class="small clearSearchLink" (click)="clear()">clear search</a>
          </p>
        </div>
      </div>
    </form>
  `
})
export class SearchListComponent {
  @Input() list: any;

  get searchTerm(): string {
    return this.listIsObject() ? (this.list.searchTerm || '') : '';
  }

  set searchTerm(value: string) {
    if (this.listIsObject()) {
      this.list.searchTerm = value;
    }
  }

  search(): void {
    if (this.listIsObject() && typeof this.list.searchList === 'function') {
      this.list.searchList();
    }
  }

  clear(): void {
    if (this.listIsObject() && typeof this.list.searchList === 'function') {
      this.list.searchList(true);
    }
  }

  private listIsObject(): boolean {
    return !!this.list && typeof this.list === 'object';
  }
}
